(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-inquiry"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('moqua-inquiry')) {
  customElements.define('moqua-inquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const pendingKey = 'moqua:contact:pending:v1';
      const success = this.querySelector('[data-inquiry-success]');
      const errors = this.querySelector('[data-inquiry-errors]');
      if (errors) {
        errors.focus();
        try { sessionStorage.removeItem(pendingKey); } catch {}
      }
      if (success) {
        success.focus();
        let pending;
        try {
          pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
          sessionStorage.removeItem(pendingKey);
        } catch { return; }
        const topics = ['kitchen', 'house', 'camping', 'refinement', 'spares', 'service', 'unsure'];
        if (!pending || !Number.isFinite(pending.created) || Date.now() - pending.created < 0 || Date.now() - pending.created > 1800000 || !topics.includes(pending.topic)) return;
        try {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
          const publish = window.Shopify?.analytics?.publish;
          if (typeof publish === 'function') {
            Promise.resolve(window.Shopify.analytics.publish('moqua:contact_success', {
              form: 'moqua_beratung', topic: pending.topic
            })).catch(() => {});
          }
        } catch {}
        return;
      }
      const form = this.querySelector('form');
      if (!form || !form.querySelector('[data-field="topic"]')) return;

      const fields = Object.fromEntries(Array.from(form.querySelectorAll('[data-field]')).map(field => [field.dataset.field, field]));
      const kitchenDetails = this.querySelector('[data-kitchen-details]');
      const kitchen = this.querySelector('[data-kitchen]');
      const kitchenOptions = this.querySelector('[data-kitchen-options]');
      const selectionPanel = this.querySelector('[data-selection]');
      const selection = fields.selection;
      const hint = this.querySelector('[data-topic-hint]');
      const params = new URLSearchParams(window.location.search);
      const topic = params.get('topic');
      const validTopic = Array.from(fields.topic.options).some(option => option.dataset.topicKey === topic);
      let selectionTopic = '';
      const clearSelection = () => {
        selection.value = '';
        selection.disabled = true;
        selectionPanel.hidden = true;
        selectionTopic = '';
      };
      const updateTopic = () => {
        const value = fields.topic.selectedOptions[0].dataset.topicKey;
        kitchenDetails.hidden = value !== 'kitchen';
        kitchenOptions.hidden = value !== 'kitchen';
        kitchenOptions.disabled = value !== 'kitchen';
        kitchen.hidden = value !== 'kitchen';
        kitchen.disabled = value !== 'kitchen';
        const template = Array.from(this.querySelectorAll('[data-topic-hint-template]')).find(item => item.dataset.topicHintTemplate === value);
        hint.textContent = template ? template.content.textContent.trim() : '';
        hint.hidden = !template;
        if (selectionTopic && selectionTopic !== value) clearSelection();
      };
      if (validTopic) {
        fields.topic.value = Array.from(fields.topic.options).find(option => option.dataset.topicKey === topic).value;
        const choice = Array.from(this.querySelectorAll('[data-inquiry-choice]')).find(item => item.dataset.inquiryChoice === params.get('choice') && item.dataset.topic === topic);
        if (choice) {
          selection.value = choice.content.textContent.trim();
          const spareQuantity = params.get('qty') === '2' ? 2 : 1;
          if (topic === 'spares' && ['spares_jrg', 'spares_nussbaum_short', 'spares_nussbaum_long'].includes(params.get('choice'))) selection.value += '\n' + this.querySelector('[data-inquiry-quantity]').content.textContent.trim() + ' ' + spareQuantity;
          if (topic === 'spares' && ['spares_nussbaum_short', 'spares_nussbaum_long'].includes(params.get('choice'))) {
            ['key', 'ring', 'em', 'stones'].forEach(extra => {
              if (params.get(extra) !== '1') return;
              const extraTemplate = this.querySelector('[data-inquiry-extra="' + extra + '"]');
              selection.value += '\n' + extraTemplate.content.textContent.trim();
            });
            const totalCents = (params.get('choice') === 'spares_nussbaum_long' ? 8050 : 5150) * spareQuantity + (params.get('key') === '1' ? 3500 : 0) + (params.get('ring') === '1' ? 1750 : 0);
            selection.value += '\n' + this.querySelector('[data-inquiry-total-label]').content.textContent.trim() + ' CHF ' + (totalCents / 100).toFixed(2);
          }
          if (topic === 'spares' && params.get('choice') === 'spares_jrg') {
            if (params.get('key') === '1') selection.value += '\n' + this.querySelector('[data-inquiry-jrg-key]').content.textContent.trim();
            ['em', 'stones'].forEach(extra => {
              if (params.get(extra) !== '1') return;
              selection.value += '\n' + this.querySelector('[data-inquiry-extra="' + extra + '"]').content.textContent.trim();
            });
            const totalCents = 5900 * spareQuantity + (params.get('key') === '1' ? 2500 : 0);
            selection.value += '\n' + this.querySelector('[data-inquiry-total-label]').content.textContent.trim() + ' CHF ' + (totalCents / 100).toFixed(2);
          }
          selection.disabled = false;
          selectionPanel.hidden = false;
          selectionTopic = topic;
        }
        fields.refinement.checked = params.get('extras') === '1';
      }
      if (['kitchen_puraup', 'kitchen_osmosis', 'kitchen_slimflow', 'camping_osmosis', 'knowledge_osmosis'].includes(params.get('choice'))) {
        const option = fields.goal.querySelector('[data-goal-key="osmosis"]');
        if (option) fields.goal.value = option.value;
      }
      updateTopic();
      if (selection.value) selection.style.height = Math.max(98, selection.scrollHeight + 2) + 'px';
      fields.topic.addEventListener('change', updateTopic);
      this.querySelector('[data-clear-selection]').addEventListener('click', () => {
        clearSelection();
        fields.topic.focus();
      });
      const contactMethod = fields.method;
      const updateContact = () => {
        fields.phone.required = contactMethod.selectedOptions[0].dataset.callback === 'true';
      };
      contactMethod.addEventListener('change', updateContact);
      updateContact();
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) return;
        try {
          sessionStorage.setItem(pendingKey, JSON.stringify({
            created: Date.now(),
            topic: fields.topic.selectedOptions[0].dataset.topicKey || 'unsure'
          }));
        } catch {}
        const submit = form.querySelector('button[type="submit"]');
        submit.setAttribute('aria-disabled', 'true');
        const hint = document.createElement('p');
        hint.className = 'moqua-inquiry__hint';
        hint.setAttribute('role', 'status');
        hint.textContent = submit.dataset.sending;
        submit.after(hint);
        window.setTimeout(() => {
          submit.removeAttribute('aria-disabled');
          hint.remove();
        }, 15000);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.moqua-navigation details[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});});
document.addEventListener('click',function(event){document.querySelectorAll('.moqua-navigation details[open]').forEach(function(menu){if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-taps"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('moqua-taps')){customElements.define('moqua-taps',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-tap-filter]');if(!button)return;const selected=button.dataset.tapFilter;this.querySelectorAll('[data-tap-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;this.querySelectorAll('[data-tap-group]').forEach(item=>{const show=selected==='all'||item.dataset.tapGroup===selected;item.hidden=!show;if(show)count++;});this.querySelector('[data-tap-count]').textContent=count;});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moqua-water-advisor"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialise(root) {
    if (root.dataset.advisorReady) return;
    root.dataset.advisorReady = 'true';
    var form = root.querySelector('[data-advisor-form]');
    var panel = root.querySelector('[data-result-panel]');
    var error = root.querySelector('[data-error]');
    function clearResult() {
      panel.hidden = true;
      panel.replaceChildren();
      error.hidden = true;
    }
    form.addEventListener('change', function (event) {
      clearResult();
      if (event.target.name.indexOf('location-') !== 0) return;
      root.querySelectorAll('[data-goals]').forEach(function (fieldset) {
        var active = fieldset.dataset.goals === event.target.value;
        fieldset.hidden = !active;
        fieldset.disabled = !active;
        fieldset.querySelectorAll('input').forEach(function (input) { input.checked = false; });
      });
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var active = form.querySelector('[data-goals]:not([disabled])');
      var goal = active && active.querySelector('input:checked');
      if (!goal) {
        error.hidden = false;
        var first = active ? active.querySelector('input') : form.querySelector('input[type="radio"]');
        if (first) first.focus();
        return;
      }
      var result = root.querySelector('template[data-result="' + goal.value + '"]');
      if (!result) return;
      panel.replaceChildren(result.content.cloneNode(true));
      var refinement = form.querySelector('[data-refinement]').checked;
      var inquiry = panel.querySelector('[data-advisor-inquiry]');
      var url = new URL(inquiry.href, window.location.origin);
      url.searchParams.set('topic', active.dataset.goals);
      url.searchParams.set('choice', goal.value);
      if (refinement) url.searchParams.set('extras', '1');
      inquiry.href = url.href;
      if (refinement) panel.appendChild(root.querySelector('[data-extra-result]').firstElementChild.cloneNode(true));
      error.hidden = true;
      panel.hidden = false;
      panel.focus({ preventScroll: true });
      panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    });
    root.querySelector('[data-reset]').addEventListener('click', function () {
      form.reset();
      clearResult();
      root.querySelectorAll('[data-goals]').forEach(function (fieldset) { fieldset.hidden = true; fieldset.disabled = true; });
      form.querySelector('input[type="radio"]').focus();
    });
  }
  document.querySelectorAll('[data-moqua-advisor]').forEach(initialise);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-moqua-advisor]').forEach(initialise); });
})();

  } catch(e) { console.error(e); }
})();
})();
